import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CbFilterPipe } from './filter.pipe';



@NgModule({
    declarations: [
        CbFilterPipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        CbFilterPipe
    ]
})
export class CbFilterModule { }
